// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M14.5 8C14.5 11.59 11.59 14.5 8 14.5C4.41 14.5 1.5 11.59 1.5 8C1.5 4.41 4.41 1.5 8 1.5C11.59 1.5 14.5 4.41 14.5 8Z',
  'M4.75 2.37C4.5 3.25 4.62 4.42 5.5 4.95C6.19 5.36 7.05 5.15 7.52 5.85C8 6.56 7.65 7.55 8.43 8.06C9.2 8.57 10.25 8.04 10.42 7.2C10.64 6.11 11.15 5.5 12.25 5.5H14',
  'M1.55 8.8H3.3C4.28 8.8 4.9 9.42 4.9 10.4C4.9 11.26 5.35 11.8 6.2 11.8C7.13 11.8 7.55 12.39 7.4 13.25L7.2 14.45',
  'M14.14 10.1H12.25C11.17 10.1 10.5 10.78 10.5 11.85V14',
];
